import styled from '@emotion/styled';
import { getImage } from '@utils/imageHelper';
import Typography from 'aquilla/core/atoms/Typography';

const ErrorToastContainer = styled.div`
  position: absolute;
  left: calc(50% - 164px);
  width: 328px;
  top: 120px;
  z-index: 100;
  height: 42px;
  gap: 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  padding: 12px;
  background-color: var(--color-red-2);
`;

const StyledText = styled(Typography)``;

const ErrorIcon = styled.img``;

const ErrorToast = ({ message }: { message: string }) => {
  return (
    <ErrorToastContainer>
      <ErrorIcon alt="" src={getImage('unacademy-ai/limit-reached.svg')} />
      <StyledText variant="h6" color="var(--color-red-1)">
        {message}
      </StyledText>
    </ErrorToastContainer>
  );
};

export default ErrorToast;
